import { LoaderFunctionArgs, redirect } from "react-router-dom";

import { MyDate, myAxios, weeknum } from "src/components/common/functions";

const allowedKeys = ["mode", "month", "week", "department"] as const;

export async function laborUsageLoader({ request }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => controller.abort());

    const url = new URL(request.url);
    const today = new MyDate();
    let shouldRedirect = false;

    for (const [key] of url.searchParams) {
        if (!allowedKeys.includes(key as typeof allowedKeys[number])) {
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }

    if (!["Month", "Week"].includes(url.searchParams.get("mode") ?? "")) {
        url.searchParams.set("mode", "Month");
        shouldRedirect = true;
    }
    if (!url.searchParams.get("month")) {
        url.searchParams.set("month", today.s().slice(0, 7));
        shouldRedirect = true;
    }
    if (!url.searchParams.get("week")) {
        url.searchParams.set("week", weeknum(today));
        shouldRedirect = true;
    }

    if (shouldRedirect) {
        throw redirect(url.pathname + "?" + url.searchParams.toString());
    }

    const formData = new FormData();
    for (const key of allowedKeys) {
        const value = url.searchParams.get(key);
        if (value !== null) formData.append(key, value);
    }

    const res = await myAxios({
        fileName: "laborUsage/readLaborUsage.php",
        formData,
        signal: controller.signal,
    });
    if (!res) throw redirect("..");

    const data = res.data;
    if (!url.searchParams.get("department") && data.departmentOptions?.[0]?.value) {
        url.searchParams.set("department", data.departmentOptions[0].value);
        throw redirect(url.pathname + "?" + url.searchParams.toString());
    }
    return data;
}
